enum PropriedadeHisEnum {
  NaoEncontrato = 'NaoEncontrato',
  StatusDoAgendamento = 'StatusDoAgendamento',
  StatusDaAutorizacaoNoAgendamento = 'StatusDaAutorizacaoNoAgendamento',
  AutorizacaoStatus = 'AutorizacaoStatus',
  TipoDeAutorizacao = 'TipoDeAutorizacao',
  AutorizacaoTipoDeInternacao = 'AutorizacaoTipoDeInternacao',
  ReservaLeito = 'ReservaLeito',
  CaraterCirurgiaHisId = 'CaraterCirurgiaHisId',
  BolsaDeSangue = 'BolsaDeSangue',
  Servico = 'Servico',
  AnestesiaDoHospital = 'AnestesiaDoHospital',
  AutorizacaoTipoGuia = 'AutorizacaoTipoGuia',
  AutorizacaoTipoDiaria = 'AutorizacaoTipoDiaria',
  AutorizacaoResponsavel = 'AutorizacaoResponsavel',
  AutorizacaoSetorResponsavel = 'AutorizacaoSetorResponsavel',
  AutorizacaoSetorOrigem = 'AutorizacaoSetorOrigem',
  InformacoesAdiconais = 'InformacoesAdiconais',
  TipoFormaAgendamento = 'TipoFormaAgendamento',
  TipoClassificacao = 'TipoClassificacao',
  TipoDeAcomodacaoHisId = 'TipoDeAcomodacaoHisId',
  CodigoProcedencia = 'CodigoProcedencia',
  NecessitaTipagemSanguinea = 'NecessitaTipagemSanguinea',
  ConvenioParticular = 'ConvenioParticular',
  TipoDeAtendimento = 'TipoDeAtendimento',
  ClassificacaoAgendaHisId = 'ClassificacaoAgendaHisId',
  StatusAutorizacaoDoOpmeNoAgendamento = 'StatusAutorizacaoDoOpmeNoAgendamento',
  StatusDoDomain = 'StatusDoDomain',
  TipoDeAtendimentoHisId = 'TipoDeAtendimentoHisId',
  CancelamentoHisId = 'CancelamentoHisId',
  TemCongelacao = 'TemCongelacao',
  AnestesiaHisId = 'AnestesiaHisId',
  FuncionarioHisId = 'FuncionarioHisId',
  ReservouHisId = 'ReservouHisId',
  TipoJustificativaHisId = 'TipoJustificativaHisId',
  TipoAlergiaHisId = 'TipoAlergiaHisId',
  AgenteCausadorHisId = 'AgenteCausadorHisId',
  ConfirmacaoAlergiaHisId = 'ConfirmacaoAlergiaHisId',
  AcaoAlergiaHisId = 'AcaoAlergiaHisId',
  IntensidadeAlergiaHisid = 'IntensidadeAlergiaHisid',
  NegaAlergiaHisId = 'NegaAlergiaHisId',
  NursingProfileHisId = 'NursingProfileHisId',
  PessoaFisicaHisIdDoUsuarioIntegrafinx = 'PessoaFisicaHisIdDoUsuarioIntegrafinx',
  ProcedimentoAutorizacao = 'ProcedimentoAutorizacao',
  UnidadeDeInternacaoHisId = 'UnidadeDeInternacaoHisId',
  TipoDeInternacaoHisId = 'TipoDeInternacaoHisId',
  TecnicaUtilizadaHisId = 'TecnicaUtilizadaHisId',
  TipoCirurgiaHisId = 'TipoCirurgiaHisId',
  NecessitaCongelacao = 'NecessitaCongelacao',
  PrioridadeHisId = 'PrioridadeHisId',
  AnestesistaHisId = 'AnestesistaHisId',
  LateralidadeHisId = 'LateralidadeHisId',
  NaturezaDaCirurgia = 'NaturezaDaCirurgia',
  TipoPagamentoHisId = 'TipoPagamentoHisId',
  OpmeHisId = 'OpmeHisId',
  ExameHisId = 'ExameHisId',
  TipoDoExame = 'TipoDoExame',
  SetorDoExameHisId = 'SetorDoExameHisId',
  TipoPagamentoAnestesistaHisId = 'TipoPagamentoAnestesistaHisId',
  Cbo = 'Cbo',
  Cid = 'Cid',
}

export default PropriedadeHisEnum
